import { render, staticRenderFns } from "./SkribbleFormA.vue?vue&type=template&id=58be8317&scoped=true&"
import script from "./SkribbleFormA.vue?vue&type=script&lang=js&"
export * from "./SkribbleFormA.vue?vue&type=script&lang=js&"
import style0 from "./SkribbleFormA.vue?vue&type=style&index=0&id=58be8317&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be8317",
  null
  
)

export default component.exports